// ============================================
// File: src/components/Footer.js
// ============================================
import React from 'react';

// ============================================
// Bilingual translations for AR/EN support
// ============================================
const translations = {
  ar: {
    about: "عن رفاد التدوير",
    aboutText: "نحن شركة رائدة في مجال إعادة التدوير المستدام، نقدم حلولاً مبتكرة للمخلفات الإلكترونية والطبية وأجهزة الاتصالات وفق أعلى المعايير البيئية.",
    quickLinks: "روابط سريعة",
    contactInfo: "معلومات الاتصال",
    copyright: "© 2026 رفاد التدوير – حلول متكاملة لإعادة تدوير الإلكترونيات، المخلفات الطبية والاتصالات.",
    privacy: "سياسة الخصوصية",
    terms: "شروط الاستخدام",
    navItems: {
      home: "الرئيسية",
      about: "من نحن",
      services: "خدماتنا",
      gallery: "المعرض",
      features: "المميزات",
      faq: "الأسئلة الشائعة",
      contact: "اتصل بنا"
    },
    address: "الرياض، المملكة العربية السعودية",
    workingHours: "الأحد - الخميس: 9ص - 6م",
    websiteCredit: "تم بناء الموقع بواسطة fahadnahar.com"  
  },
  en: {
    about: "About Rafad Recycling",
    aboutText: "We are a leading company in sustainable recycling, providing innovative solutions for electronic, medical, and telecom waste according to the highest environmental standards.",
    quickLinks: "Quick Links",
    contactInfo: "Contact Information",
    copyright: "© 2026 Rafad Recycling – Integrated solutions for electronics, medical, and telecom waste recycling.",
    privacy: "Privacy Policy",
    terms: "Terms of Use",
    navItems: {
      home: "Home",
      about: "About Us",
      services: "Services",
      gallery: "Gallery",
      features: "Features",
      faq: "FAQ",
      contact: "Contact Us"
    },
    address: "Riyadh, Saudi Arabia",
    workingHours: "Sunday - Thursday: 9 AM - 6 PM",
    websiteCredit: "Website built by fahadnahar.com"
  }
};

 
const Footer = ({ currentLang }) => {
  const t = translations[currentLang];
  const isRTL = currentLang === 'ar';
  
 
  const navItems = [
    { id: 'home', label: t.navItems.home },
    { id: 'about', label: t.navItems.about },
    { id: 'services', label: t.navItems.services },
    { id: 'gallery', label: t.navItems.gallery },
    { id: 'features', label: t.navItems.features },
    { id: 'faq', label: t.navItems.faq },
    { id: 'contact', label: t.navItems.contact }
  ];

 
  const scrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <footer className="footer" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="footer-container">
        {/* About Section */}
        <div className="footer-section">
          <h3>{t.about}</h3>
          <p>{t.aboutText}</p>
          <div className="footer-social">
            <a href="#"><i className="fab fa-linkedin-in"></i></a>
            <a href="#"><i className="fab fa-twitter"></i></a>
            <a href="#"><i className="fab fa-instagram"></i></a>
            <a href="#"><i className="fab fa-facebook-f"></i></a>
          </div>
        </div>
        
        {/* Quick Links Section */}
        <div className="footer-section">
          <h3>{t.quickLinks}</h3>
          <ul className="footer-links">
            {navItems.map(item => (
              <li key={item.id}>
                <a href={`#${item.id}`} onClick={(e) => { e.preventDefault(); scrollTo(item.id); }}>
                  <i className={`fas fa-chevron-${isRTL ? 'right' : 'left'}`}></i> {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        
        {/* Contact Information Section */}
        <div className="footer-section">
          <h3>{t.contactInfo}</h3>
          <ul className="footer-contact-info">
            <li>
              <i className="fas fa-map-marker-alt"></i> 
              <span dir="auto">{t.address}</span>
            </li>
            <li>
              <i className="fas fa-phone-alt"></i> 
              <span className="phone-number" dir="ltr">+966 59 960 4444</span>
            </li>
            <li>
              <i className="fas fa-envelope"></i> 
              <span dir="ltr">info@rifadrecycling.sa</span>
            </li>
            <li>
              <i className="fas fa-clock"></i> 
              <span>{t.workingHours}</span>
            </li>
          </ul>
        </div>
      </div>
      
      {/* Copyright and Legal Links */}
      <div className="footer-bottom">
        <p dir="auto">{t.copyright}</p>
        <p style={{ marginTop: '0.5rem', fontSize: '0.8rem' }}>
           
        </p>
        
        {/* إضافة نص صنع الموقع - يظهر في جميع اللغات */}
        {t.websiteCredit && (
          <div className="website-credit">
            <a 
              href="https://fahadnahar.com" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              {t.websiteCredit}
            </a>
          </div>
        )}
      </div>

      {/* Component Styles */}
      <style>{`
        .footer {
          background: linear-gradient(135deg, #f5f7fa 0%, #e8edf2 100%);
          border-top: 1px solid rgba(83, 176, 150, 0.2);
          padding: 3rem 5% 1.5rem;
          margin-top: 2rem;
        }
        
        .footer-container {
          max-width: 1200px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 2rem;
          margin-bottom: 2rem;
        }
        
        .footer-section h3 {
          font-size: 1.3rem;
          font-weight: 700;
          margin-bottom: 1.2rem;
          color: #1a2a3a;
          position: relative;
          display: inline-block;
        }
        
        .footer-section h3:after {
          content: '';
          position: absolute;
          bottom: -8px;
          ${isRTL ? 'right: 0;' : 'left: 0;'}
          width: 40px;
          height: 3px;
          background: linear-gradient(90deg, #53b096, #71b887);
          border-radius: 2px;
        }
        
        .footer-section p {
          color: #5a6a7a;
          line-height: 1.8;
        }
        
        .footer-links {
          list-style: none;
          padding: 0;
        }
        
        .footer-links li {
          margin-bottom: 0.8rem;
        }
        
        .footer-links a {
          color: #5a6a7a;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        
        .footer-links a:hover {
          color: #53b096;
          transform: ${isRTL ? 'translateX(5px)' : 'translateX(-5px)'};
        }
        
        .footer-contact-info {
          list-style: none;
          padding: 0;
        }
        
        .footer-contact-info li {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 1rem;
          color: #5a6a7a;
          transition: all 0.3s ease;
        }
        
        .footer-contact-info li:hover {
          transform: ${isRTL ? 'translateX(5px)' : 'translateX(-5px)'};
          color: #53b096;
        }
        
        .footer-contact-info li i {
          width: 30px;
          color: #53b096;
          font-size: 1.1rem;
        }
        
        /* حل مشكلة انعكاس الأرقام */
        .phone-number {
          direction: ltr;
          display: inline-block;
          unicode-bidi: embed;
        }
        
        .footer-social {
          display: flex;
          gap: 1rem;
          margin-top: 1rem;
        }
        
        .footer-social a {
          width: 40px;
          height: 40px;
          background: rgba(83, 176, 150, 0.1);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
          color: #53b096;
          text-decoration: none;
        }
        
        .footer-social a:hover {
          background: #53b096;
          color: white;
          transform: translateY(-3px);
        }
        
        .footer-bottom {
          text-align: center;
          padding-top: 2rem;
          border-top: 1px solid rgba(83, 176, 150, 0.15);
          color: #6a7a8a;
        }
        
        .footer-bottom a {
          color: #53b096;
          text-decoration: none;
        }
        
        .footer-bottom a:hover {
          color: #71b887;
        }
        
        /* تنسيق نص صنع الموقع */
        .website-credit {
          margin-top: 1.5rem;
          font-size: 0.75rem;
          opacity: 0.7;
        }
        
        .website-credit a {
          color: #53b096;
          text-decoration: none;
          transition: all 0.3s ease;
        }
        
        .website-credit a:hover {
          color: #3a7b66;
          text-decoration: underline;
        }
        
        /* Responsive Design */
        @media (max-width: 768px) {
          .footer { 
            padding: 2rem 5% 1.5rem;
          }
          
          .footer-container { 
            grid-template-columns: 1fr; 
            text-align: center; 
          }
          
          .footer-section h3:after { 
            left: 50% !important;
            right: 50% !important;
            transform: translateX(-50%); 
          }
          
          .footer-links a { 
            justify-content: center; 
          }
          
          .footer-links a:hover {
            transform: translateX(0) translateY(-2px);
          }
          
          .footer-contact-info li { 
            justify-content: center; 
          }
          
          .footer-contact-info li:hover {
            transform: translateX(0) translateY(-2px);
          }
          
          .footer-social { 
            justify-content: center; 
          }
        }
        
        /* تحسينات للشاشات الكبيرة */
        @media (min-width: 1440px) {
          .footer {
            padding: 4rem 5% 2rem;
          }
          
          .footer-container {
            max-width: 1400px;
            gap: 3rem;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;